<template>
  <div>
    <iframe class="iframe" src="/stock-index-detail" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  mounted() {
    window.addEventListener("message", (data) => {
      console.log(data);
    });
  },
};
</script>

<style lang="scss" scoped>
.iframe {
  width: 100%;
  height: 100vh;
}
</style>
